import * as React from "react";

import { QNProps as QNParams } from "@ezbuy/smartimagesrc/lib/ImageSrcHandlers/Handler";
import { BannerContainerBox } from "./styles";
import { formatAspect } from "utils/playground/banner";
import { TBannerItem } from "views/services/banner";
import ImageView from "../SmartImage";
interface BannerContainerProps {
	children?: React.ReactNode;
	/** 布局所需size */
	gridWidth?: string;
	gridHeight?: string;
	/** 七牛图片size参数 */
	width?: number;
	height?: number;
	banner: TBannerItem;
	keepSize?: boolean;
	qnParams?: QNParams;
	id?: string;
	className?: string;
	imgClassName?: string;
	style?: React.CSSProperties;
	placeholderBg: string;
}
export const BannerContainer = (props: BannerContainerProps) => {
	const {
		banner,
		className = "",
		style = {},
		keepSize,
		imgClassName = "",
		placeholderBg,
		gridHeight,
		gridWidth,
	} = props;
	const width = formatAspect(props.width || +(banner.width || 0));
	let qnParams = props.qnParams;
	if (width) {
		qnParams = {
			...qnParams,
			w: width,
		};
	}
	const imgHeight = gridHeight ? { height: gridHeight } : null;
	return (
		<BannerContainerBox
			data-id={props.id}
			className={className}
			style={{ ...style, backgroundRepeat: "no-repeat" }}
			id={props.id}
			width={gridWidth}
			height={gridHeight}
		>
			<ImageView
				src={banner.img}
				online={true}
				imgClass={imgClassName}
				qnParams={qnParams}
				keepSize={keepSize}
				placeholder={placeholderBg}
				fallbackSrc={placeholderBg}
				style={{ width: gridWidth ?? "100%", ...imgHeight }}
			/>
			{props.children}
		</BannerContainerBox>
	);
};
